import { render } from "./adminPage.vue?vue&type=template&id=95ced240"
import script from "./adminPage.vue?vue&type=script&lang=js"
export * from "./adminPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__